import { useState } from "react";

const WA_LINK = "https://wa.me/50766132697?text=Hola%2C%20quiero%20agendar%20una%20cita%20con%20el%20Dr.%20Erick%20Tejada";

const services = [
  {
    id: "colposcopia",
    icon: "ri-microscope-line",
    title: "Colposcopia Digital",
    tag: "Servicio Principal",
    tagColor: "bg-teal-100 text-teal-700",
    image: "https://public.readdy.ai/ai/img_res/1e4ead4ff3a4a52ab3f22b787dbc5ba2.jpg",
    description:
      "La colposcopia es un examen detallado del cuello uterino mediante un instrumento óptico de alta resolución llamado colposcopio. Permite al Dr. Tejada visualizar con claridad cualquier área anormal que no sea visible a simple vista, tomando biopsias cuando es necesario.",
    why: "Es el estudio más completo para evaluar el cuello uterino tras un Pap anormal o una prueba de VPH positiva. Detecta lesiones en etapas muy tempranas, cuando el tratamiento es más efectivo y conservador.",
    benefits: [
      "Diagnóstico visual de alta precisión",
      "Permite toma de biopsias dirigidas",
      "Rápido y ambulatorio (20-30 minutos)",
      "Detecta lesiones antes de que progresen",
      "Tecnología digital de última generación",
    ],
    waMessage: "Hola%2C%20quiero%20agendar%20una%20colposcopia%20con%20el%20Dr.%20Erick%20Tejada",
  },
  {
    id: "papanicolaou",
    icon: "ri-test-tube-line",
    title: "Papanicolaou (Pap)",
    tag: "Más Solicitado",
    tagColor: "bg-emerald-100 text-emerald-700",
    image: "https://readdy.ai/api/search-image?query=Laboratory%20cytology%20microscope%20slides%20cervical%20pap%20smear%20test%20in%20clinical%20laboratory%2C%20clean%20medical%20environment%2C%20teal%20and%20white%20tones%2C%20professional%20pathology%20lab%2C%20scientific%20medical%20setting%2C%20no%20people&width=700&height=500&seq=svc002&orientation=landscape",
    description:
      "El Papanicolaou (o citología cervical) es un examen preventivo que consiste en la toma de una muestra de células del cuello uterino para analizarlas en el laboratorio. Es el examen de detección más importante para la salud ginecológica de la mujer.",
    why: "El Pap permite detectar cambios celulares anormales mucho antes de que se conviertan en cáncer. Las mujeres que se realizan este estudio regularmente tienen hasta un 95% menos de riesgo de desarrollar cáncer cervicouterino.",
    benefits: [
      "Prevención del cáncer cervicouterino",
      "Procedimiento rápido e indoloro",
      "Recomendado desde los 21 años",
      "Resultados confiables y precisos",
      "Guía el plan de seguimiento médico",
    ],
    waMessage: "Hola%2C%20quiero%20agendar%20un%20Papanicolaou%20con%20el%20Dr.%20Erick%20Tejada",
  },
  {
    id: "tipificacion",
    icon: "ri-virus-line",
    title: "Tipificación Viral / Genotipificación",
    tag: "Diagnóstico Molecular",
    tagColor: "bg-amber-100 text-amber-700",
    image: "https://readdy.ai/api/search-image?query=Advanced%20molecular%20biology%20laboratory%20with%20PCR%20genotyping%20equipment%20for%20viral%20typing%2C%20clean%20scientific%20environment%20with%20teal%20and%20white%20tones%2C%20professional%20research%20lab%20setting%2C%20no%20people&width=700&height=500&seq=svc003&orientation=landscape",
    description:
      "La tipificación viral y genotipificación del VPH es una prueba molecular avanzada que no solo detecta la presencia del Virus del Papiloma Humano, sino que identifica exactamente qué tipo o genotipo está presente. Esto permite conocer el nivel de riesgo oncogénico y personalizar el plan de seguimiento.",
    why: "No todos los tipos de VPH son iguales. Los genotipos 16 y 18 son responsables del 70% de los cánceres cervicouterinos. Conocer el genotipo específico permite al Dr. Tejada diseñar un plan de vigilancia y tratamiento mucho más preciso y efectivo.",
    benefits: [
      "Identifica el genotipo exacto del VPH",
      "Diferencia tipos de alto y bajo riesgo oncogénico",
      "Mayor precisión que la prueba de VPH convencional",
      "Orienta el plan de seguimiento personalizado",
      "Muestra tomada rápidamente en consulta",
    ],
    waMessage: "Hola%2C%20quiero%20hacerme%20la%20tipificaci%C3%B3n%20viral%20con%20el%20Dr.%20Erick%20Tejada",
  },
  {
    id: "cirugia",
    icon: "ri-surgical-mask-line",
    title: "Cirugía Ambulatoria Cervical",
    tag: "Tratamiento",
    tagColor: "bg-rose-100 text-rose-700",
    image: "https://readdy.ai/api/search-image?query=Modern%20outpatient%20surgery%20room%20for%20minor%20gynecological%20procedures%2C%20clean%20sterile%20environment%20with%20medical%20equipment%2C%20teal%20and%20white%20color%20scheme%2C%20professional%20surgical%20suite%2C%20no%20people&width=700&height=500&seq=svc004&orientation=landscape",
    description:
      "Los procedimientos quirúrgicos ambulatorios del cuello uterino incluyen técnicas como la LEEP (escisión electroquirúrgica con asa), crioterapia y conización. Son tratamientos efectivos para eliminar lesiones precancerosas del cuello uterino de forma segura.",
    why: "Cuando se detectan lesiones de alto grado (NIC II o NIC III) a través de la colposcopia o biopsia, el tratamiento quirúrgico oportuno evita la progresión a cáncer. Son procedimientos seguros con recuperación rápida.",
    benefits: [
      "No requiere hospitalización",
      "Recuperación rápida (días)",
      "Alta tasa de éxito terapéutico",
      "Técnicas mínimamente invasivas",
      "Seguimiento post-procedimiento incluido",
    ],
    waMessage: "Hola%2C%20quiero%20consultar%20sobre%20cirug%C3%ADa%20cervical%20con%20el%20Dr.%20Erick%20Tejada",
  },
  {
    id: "ginecologia",
    icon: "ri-heart-pulse-line",
    title: "Ginecología General",
    tag: "Atención Integral",
    tagColor: "bg-teal-100 text-teal-700",
    image: "https://readdy.ai/api/search-image?query=Welcoming%20gynecology%20consultation%20room%20with%20comfortable%20examination%20table%2C%20medical%20posters%2C%20clean%20teal%20and%20white%20decor%2C%20warm%20professional%20medical%20office%2C%20plants%2C%20no%20people&width=700&height=500&seq=svc005&orientation=landscape",
    description:
      "La consulta de ginecología general abarca la evaluación integral de la salud femenina: revisión ginecológica anual, evaluación de síntomas, orientación sobre anticoncepción, manejo de infecciones y seguimiento de la salud reproductiva.",
    why: "La revisión ginecológica periódica es fundamental para mantener la salud femenina en todas las etapas de la vida. Una consulta regular permite identificar y tratar condiciones antes de que se vuelvan más complejas.",
    benefits: [
      "Examen ginecológico completo",
      "Orientación en anticoncepción",
      "Manejo de infecciones vaginales",
      "Evaluación de salud hormonal",
      "Seguimiento personalizado",
    ],
    waMessage: "Hola%2C%20quiero%20agendar%20una%20consulta%20ginecol%C3%B3gica%20con%20el%20Dr.%20Erick%20Tejada",
  },
];

const faqs = [
  {
    q: "¿La colposcopia duele?",
    a: "La colposcopia generalmente es un procedimiento tolerable. Algunas pacientes pueden sentir una leve molestia o presión, similar a la del Pap. Dura entre 15 y 30 minutos y no requiere anestesia en la mayoría de los casos.",
  },
  {
    q: "¿Con qué frecuencia debo hacerme el Papanicolaou?",
    a: "Se recomienda realizarse el Pap anualmente desde los 21 años o al inicio de la vida sexual. Dependiendo de tus resultados y factores de riesgo, el Dr. Tejada te indicará el esquema de seguimiento más adecuado para ti.",
  },
  {
    q: "¿Qué debo hacer si me diagnosticaron VPH?",
    a: "Mantén la calma. El VPH es muy común y en la mayoría de los casos el sistema inmune lo elimina solo. Lo más importante es el seguimiento médico adecuado. El Dr. Tejada evaluará tu caso específico y te guiará en los próximos pasos.",
  },
  {
    q: "¿Cuánto tiempo tarda en entregarse el resultado del Pap?",
    a: "Los resultados del Papanicolaou generalmente están disponibles entre 3 y 7 días hábiles. Una vez listos, el Dr. Tejada te los explicará de forma clara y sencilla.",
  },
  {
    q: "¿Cómo agendo una cita?",
    a: "La forma más rápida es por WhatsApp al número +507 6613-2697. La atención es de lunes a viernes de 9:00 AM a 5:00 PM, con cita previa.",
  },
  {
    q: "¿Qué forma de pago aceptan?",
    a: "Aceptamos pagos en efectivo y por Yappy. No se aceptan tarjetas de crédito ni débito. Por favor, prepara el pago al momento de tu consulta.",
  },
];

export default function ServicesDetail() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <div className="flex flex-col gap-0">
      {/* Services */}
      <div className="flex flex-col">
        {services.map((s, i) => (
          <div
            key={s.id}
            className={`py-12 md:py-20 ${i % 2 === 0 ? "bg-white" : "bg-slate-50"}`}
          >
            <div className="max-w-6xl mx-auto px-5 md:px-8">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
                {/* Image — always on top on mobile, alternates on desktop */}
                <div className={`rounded-2xl overflow-hidden border border-slate-100 ${i % 2 !== 0 ? "lg:order-2" : ""}`}>
                  <img
                    src={s.image}
                    alt={`${s.title} - Dr. Erick Tejada Panamá`}
                    title={`${s.title} en Ciudad de Panamá`}
                    className="w-full h-52 sm:h-64 md:h-80 object-cover object-top"
                  />
                </div>

                {/* Content */}
                <div className={`${i % 2 !== 0 ? "lg:order-1" : ""}`}>
                  <span
                    className={`inline-block text-xs font-semibold px-3 py-1 rounded-full mb-4 ${s.tagColor}`}
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    {s.tag}
                  </span>

                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl bg-teal-100 flex-shrink-0">
                      <i className={`${s.icon} text-teal-600 text-lg md:text-xl`}></i>
                    </div>
                    <h2
                      className="text-xl sm:text-2xl md:text-3xl font-bold text-slate-800"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      {s.title}
                    </h2>
                  </div>

                  <p
                    className="text-slate-600 text-sm md:text-base leading-relaxed mb-4"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    {s.description}
                  </p>

                  <div className="bg-teal-50 border border-teal-100 rounded-xl p-4 mb-4">
                    <p
                      className="text-teal-800 font-semibold text-sm mb-1"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      ¿Por qué es importante?
                    </p>
                    <p
                      className="text-teal-700 text-sm leading-relaxed"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      {s.why}
                    </p>
                  </div>

                  <ul className="space-y-2 mb-6">
                    {s.benefits.map((b) => (
                      <li key={b} className="flex items-center gap-3">
                        <div className="w-5 h-5 flex items-center justify-center rounded-full bg-teal-100 flex-shrink-0">
                          <i className="ri-check-line text-teal-600 text-xs"></i>
                        </div>
                        <span
                          className="text-slate-600 text-sm"
                          style={{ fontFamily: "'Poppins', sans-serif" }}
                        >
                          {b}
                        </span>
                      </li>
                    ))}
                  </ul>

                  <a
                    href={`https://wa.me/50766132697?text=${s.waMessage}`}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white font-semibold px-6 py-3 rounded-full transition-all text-sm whitespace-nowrap cursor-pointer"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    <i className="ri-whatsapp-line"></i>
                    Agendar {s.title}
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* FAQ */}
      <div className="py-14 md:py-24 bg-white">
        <div className="max-w-3xl mx-auto px-5 md:px-8">
          {/* Payment notice — Efectivo y Yappy */}
          <div className="flex items-start gap-4 bg-amber-50 border border-amber-200 rounded-2xl px-5 py-4 mb-10">
            <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-amber-100 flex-shrink-0">
              <i className="ri-money-dollar-circle-line text-amber-600 text-lg"></i>
            </div>
            <div>
              <p
                className="font-semibold text-amber-800 text-sm mb-1"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                Formas de pago aceptadas
              </p>
              <div className="flex flex-wrap gap-2 mt-1">
                <span
                  className="inline-flex items-center gap-1.5 bg-amber-100 text-amber-800 text-xs font-medium px-3 py-1 rounded-full"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  <i className="ri-money-dollar-circle-line text-amber-600"></i>
                  Efectivo
                </span>
                <span
                  className="inline-flex items-center gap-1.5 bg-teal-100 text-teal-800 text-xs font-medium px-3 py-1 rounded-full"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  <i className="ri-smartphone-line text-teal-600"></i>
                  Yappy
                </span>
              </div>
              <p
                className="text-amber-700 text-xs mt-2"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                No se aceptan tarjetas de crédito ni débito.
              </p>
            </div>
          </div>

          <div className="text-center mb-10">
            <span
              className="inline-block text-teal-600 text-xs md:text-sm font-semibold uppercase tracking-wider mb-3"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Preguntas Frecuentes
            </span>
            <h2
              className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-800"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Resolvemos tus dudas
            </h2>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, idx) => (
              <div key={idx} className="border border-slate-200 rounded-xl overflow-hidden">
                <button
                  className="w-full flex items-center justify-between px-5 md:px-6 py-4 text-left hover:bg-slate-50 transition-colors cursor-pointer"
                  onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                >
                  <span
                    className="font-semibold text-slate-800 text-sm pr-4"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    {faq.q}
                  </span>
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className={`ri-${openFaq === idx ? "subtract" : "add"}-line text-teal-600`}></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${openFaq === idx ? "max-h-60" : "max-h-0"}`}
                >
                  <p
                    className="px-5 md:px-6 pb-4 text-slate-600 text-sm leading-relaxed"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    {faq.a}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-10">
            <p
              className="text-slate-500 text-sm mb-4"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              ¿Tienes más preguntas? Escríbenos directamente.
            </p>
            <a
              href={WA_LINK}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-semibold px-7 py-3 rounded-full transition-all text-sm whitespace-nowrap cursor-pointer"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              <i className="ri-whatsapp-line"></i>
              Consultar por WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
